(function () {
	"use strict";
	var $ = avm.require("jquery");

	//$_ refers to jQuery added into Text file
	if (typeof $_ !== 'undefined') {
		$ = $_;
	}

	$(document).ready(function() {
		$("#business-support-contact-form").load("business-support-contact-form", function() {
			initAvastForm();

			$('#AVform *:input[type!=hidden]:first').focus();
			
			//DS TWEAKS	
			[].forEach.call(
				document.querySelectorAll(".form-group input:not([type=submit]), .form-group textarea"),
				function(el) {
					el.classList.add("form-control");
				}
			);
			[].forEach.call(
				document.querySelectorAll(".form-group select"),
				function(el) {
					el.classList.add("custom-select");
				}
			);
			[].forEach.call(
				document.querySelectorAll(".form-group .button"),
				function(el) {
					el.classList.add("btn");
					el.classList.add("btn-primary");
				}
			);
			

			var labels = document.querySelectorAll(".form-group .label");
			var i = labels.length;

			while (i--) {
            	var label = labels.item(i);
            	var text = label.textContent;
            	var isRequired = label.parentNode.classList.contains("required");        
            	var nextElement = label.nextElementSibling.firstChild;
            	
            	if (nextElement) {      
            		 //Aria
            	    nextElement.setAttribute("aria-label", text.replace(':', ''));
            	    if (isRequired) {
            	        nextElement.setAttribute("aria-required", true);            	        
            	    }

            	    //Placeholder
            		if (nextElement.tagName == 'SELECT') {
            			nextElement.options[0].text = text;
            		} else {
            			nextElement.setAttribute("placeholder", text);
            		}
            		
            		label.parentNode.removeChild(label);
            	}
            }
	    });
	});

})();
